import React from "react"
import { Flex, Radio, Stack, RadioGroup, Text, Box } from "@chakra-ui/react"

type Props = {
  region: string
  slug: string
}

export const LocaleRadio: React.FC<Props> = ({ region, slug }) => (
  <Box mx={3}>
    <Text textAlign="center">
      Please note: automatic updates are currently unavailable in live preview
      for the US locale. You can still use live preview, but will have to
      refresh manually to see your change.
    </Text>
    <Text fontWeight="bold" textAlign="center">
      Choose locale:
    </Text>
    <Flex p={1} justifyContent="center">
      <RadioGroup
        onChange={() => {
          window.location.replace(region === "us" ? slug : `/us/${slug}`)
        }}
        value={region}
      >
        <Stack direction="row">
          <Radio value="uk">UK</Radio>
          <Radio value="us">US</Radio>
        </Stack>
      </RadioGroup>
    </Flex>
  </Box>
)
